<script>

import AvatarProfil from "@/components/profil/AvatarProfil.vue";
import {mapStores} from "pinia";
import {useAuthStore} from "@/stores/auth";
export default {
  name: 'PanelLinkAccount',
  components: {AvatarProfil},
  props: {
    profil: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStores(useAuthStore)
  }
}
</script>

<template>
  <div class="w-full lg:w-1/4 bg-white lg:p-6">
    <div class="mb-8 hidden lg:block">
      <div class="w-20 h-20 bg-gray-300 rounded-full overflow-hidden">
        <avatar-profil :value="profil.lastname + profil.firstname" />
      </div>
      <h2 class="mt-4 text-xl font-semibold">{{ profil.lastname }} {{ profil.firstname }}</h2>
      <p class="text-sm text-gray-500">{{ profil.email }}</p>
    </div>
    <nav class="space-y-4">
      <router-link to="/mon-compte" class="block text-primary-700 font-semibold">
        Vos informations
      </router-link>
      <router-link to="/mes-commandes" class="block text-gray-700 hover:text-primary-800">
        Vos commandes
      </router-link>
      <router-link to="/mes-favoris" class="block text-gray-700 hover:text-primary-800">
        Vos favoris
      </router-link>
      <router-link to="/mes-avis" class="block text-gray-700 hover:text-primary-800">
        Mes avis
      </router-link>
      <router-link v-if="authStore.isAdmin" to="/admin" class="block text-gray-700 hover:text-primary-800">
        Administration
      </router-link>
    </nav>
  </div>
</template>
